import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Grid, Typography, Button, Stack, Chip, Popper, ClickAwayListener, Grow, IconButton, Paper, CardMedia, } from "@mui/material";
import Schedule from './Schedule';
import Safety from './Safety';
import Quality from './Quality';
import Kpis from './Kpis';
import ProjectImages from './ProjectImages';
import DesignAndEngineering from './DesignAndEngineering';
import * as Yup from "yup";
import { Form, Formik } from "formik";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import { useLazyGetHSEKpisQuery } from 'store/slices/apis/hseDashboardSlice';
import ihgImg from "assets/images/ihg.png";
import psaImg from "assets/images/psa.png";
import { useAuth } from 'context/AuthContext';
import UserAssets from 'components/UserAssets';
import { useGetUserProjectAssetsQuery } from 'store/slices/apis/userAssetSlice';
import { useLazyGetDesignKpisByAssetsQuery, useLazyGetNCRStatusCountByAssetsQuery, useLazyGetProcurementKpiQuery, useLazyGetScheduleKpisByAssetsQuery } from 'store/slices/apis/customerDashboardSlice';
import Assets from './Assets';
import nhlmlImg from "assets/images/nhlml.jpg";
import safexpressImg from "assets/images/safeexpress.png";
import CommentsAndRemarks from "./CommentsAndRemarks";
import ProcurementKPI from './ProcurementKPI';
import Dependencies from './Dependencies';


const validationSchema = Yup.object({
    category: Yup.string().nullable(),
    subCategory: Yup.string().nullable(),
    wbsId: Yup.string().nullable(),
    assetName: Yup.string().nullable(),
});

const customers = {
    "ihg": {
        title: "IHG",
        icon: ihgImg
    },
    "psa": {
        title: "PSA",
        icon: psaImg
    },
    "nhlml": {
        title: "NHLML",
        icon: nhlmlImg
    },
    "safexpress": {
        title: "Safexpress",
        icon: safexpressImg
    }
}

const SafexpressDashboard = () => {
    const navigate = useNavigate()
    const { projectId } = useParams();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const arrowRef = useRef(null);
    const [isApplyFilter, setIsApplyFIlter] = useState(false);
    const [filters, setFilters] = useState({
        projectId: projectId,
        assetName: "",
        assetId: "",
        // parentId: ""
    });

    //const { data: scheduleKpiData, error: scheduleKpiError, isLoading: scheduleKpiLoading } = useGetScheduleKpisQuery({ projectId });
    const [scheduleTrigger, { data: scheduleAssetData, error: scheduleAssetError, isLoading: scheduleAssetLoading }] = useLazyGetScheduleKpisByAssetsQuery({ projectId });
    // const { data: costKpiData, error: costKpiError, isLoading: costKpiLoading } = useGetCostKpisQuery({ projectId })
    // const { data: ncrData, error: ncrIsError, isLoading: ncrIsLoading } = useGetNCRStatusCountQuery(projectId)
    //const [trigger, { data, isLoading, isError, error }] = useLazyGetScheduleKpisQuery();
    // const { data: designData, isLoading: designLoading, error: designError } = useGetDesignKpisQuery(projectId);
    const [ncrTrigger, { data: ncrData, isLoading: ncrIsLoading, error: ncrIsError }] = useLazyGetNCRStatusCountByAssetsQuery();
    const [designTrigger, { data: designData, isLoading: designLoading, error: designError }] = useLazyGetDesignKpisByAssetsQuery();
    const [procurementKpiTrigger, { data: procurementKpiData, isLoading: procurementKpiLoading, error: procurementKpiError }] = useLazyGetProcurementKpiQuery();
    const [hseTrigger, { data: hseData, isError: hseError, isFetching: hseLoading }] = useLazyGetHSEKpisQuery({ projectId });
    const { user } = useAuth();
    //console.log("user", user)
    useEffect(() => {
        // console.log("User →", user);
        // console.log("Roles →", user?.roles);
        if (!user) return;
        if (user && user?.roles && !user?.roles?.includes("Customer")) {
            // navigate(`/projects/${projectId}`)
        }
    }, [user])
    const { data: userAssets = [], isFetching: assetsLoading, isError: assetError } = useGetUserProjectAssetsQuery(
        { projectId, userId: '025069e3-d196-4da8-9333-f48bbc376686' },
        { skip: !projectId || !'025069e3-d196-4da8-9333-f48bbc376686' }
    );

    const assetIds = userAssets.map(a => a.assetActivityId);
    const assetNames = userAssets.map(a => a.assetName);
    const sortedAssets = useMemo(() => {
        if (!userAssets?.length) return [];

        return [...userAssets].sort((a, b) =>
            (a?.assetName ?? "").localeCompare(b?.assetName ?? "", undefined, {
                sensitivity: "base",
            })
        );
    }, [userAssets]);


    useEffect(() => {
        const payload = {
            projectId,
            //assetId: filters.assetId || ""
        };
        hseTrigger(payload);
        procurementKpiTrigger({ projectId, SubProject: "Warehouse-3" })
    }, []);

    useEffect(() => {
        if (!assetsLoading && userAssets.length > 0) {

            const schedulePayload = {
                projectId,
                assetIds
            };

            const ncrPayload = {
                projectId,
                assetNames
            };

            const designPayload = {
                projectId,
                assetNames
            };


            // procurementKpiTrigger({ projectId, SubProject: "Warehouse-3" })
        }
        scheduleTrigger({ projectId, assetIds });
        ncrTrigger({ projectId, assetNames });
        designTrigger({ projectId, assetNames });
    }, [assetsLoading, userAssets]);


    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleApplyFilters = async (values, { setSubmitting }) => {
        // console.log("Apply filters →", values);

        const payload = {
            projectId: projectId,
            // category: values.category || "",
            // subCategory: values.wbsId || "",
            // parentId: values.wbsId || "",
            // activityId: values.wbsId || "",
            assetId: values.assetId || ""
        };

        // keep name for showing in Chip / text
        const newFilters = {
            ...payload,
            assetName: values.assetName || ""
        };

        console.log("New filters →", newFilters);
        setFilters(newFilters);

        const schedulePayload = {
            projectId,
            assetIds: values.assetId ? [values.assetId] : assetIds
        };

        const ncrPayload = {
            projectId,
            assetNames: values.assetName ? [values.assetName] : assetNames
        };

        scheduleTrigger(schedulePayload);
        ncrTrigger(ncrPayload);
        designTrigger(ncrPayload);


        setIsApplyFIlter(true);
        setOpen(false);
        setSubmitting(false);
    };

    const handleReset = (resetForm) => {
        resetForm();
        resetAllFilters();
    };

    // Clears filters + reloads APIs
    const resetAllFilters = () => {
        const resetValues = {
            projectId,
            assetId: "",
            assetName: "",
            // category: "",
            // subCategory: "",
            // activity: "",
            // wbsId: "",
            // assetName: "",
            // parentId: "",
            // activityId: ""
        };

        // update local filters state
        setFilters(resetValues);
        const schedulePayload = {
            projectId,
            assetIds
        };

        const ncrPayload = {
            projectId,
            assetNames
        };

        const designPayload = {
            projectId,
            assetNames
        };

        scheduleTrigger(schedulePayload);
        procurementKpiTrigger({ projectId, SubProject: "Warehouse-3" })
        ncrTrigger(ncrPayload);
        designTrigger(designPayload);
        // scheduleTrigger(resetValues);
        // ncrTrigger(resetValues);
        // designTrigger(resetValues);

        setIsApplyFIlter(false);
        setOpen(false);
    };

    function getCustomerDetails(email) {
        if (!email) return null;

        return Object.keys(customers).find(key => email.includes(key))
            ? customers[Object.keys(customers).find(key => email.includes(key))]
            : null;
    }

    const customer = getCustomerDetails('admin@safexpress.com')

    const finalNcrData = useMemo(() => {
        if (!ncrData) return null;

        if (customer?.title === 'Safexpress') {
            return {
                ...ncrData,
                data: {
                    ...ncrData.data,
                    data: {
                        ...ncrData.data.data,
                        // Your specific Safexpress Overrides
                        total: 0,
                        statusCounts: {
                            "Closed": 0,
                            "Open": 0
                        }
                    }
                }
            };
        }

        return ncrData;
    }, [ncrData, customer?.title]);

    const finalHseData = useMemo(() => {
        if (!hseData) return null;

        if (customer?.title === 'Safexpress') {
            return {
                ...hseData,
                data: {
                    ...hseData.data,
                    totalSafeManHours: 1008,
                    totalManHours: 1008,
                    nearMissIncidents: 0
                    // data: {
                    //     // ...hseData.data.data,
                    //     // Your specific Safexpress Overrides
                    //     totalSafeManHours: 0,
                    // }
                }
            };
        }

        return hseData;
    }, [hseData, customer?.title]);

    const finalDesignData = useMemo(() => {
        if (!designData) return null;

        if (customer?.title === 'Safexpress') {
            return {
                ...designData,
                data: {
                    ...designData.data,
                    totalDrawingsSubmitted: 50,
                    drawingUnderReview: 10,
                    totalDrawingsApproved: 9,
                    drawingDelayed: 0
                    // data: {
                    //     // ...designData.data.data,
                    //     // Your specific Safexpress Overrides
                    //     totalSafeManHours: 0,
                    // }
                }
            };
        }

        return designData;
    }, [designData, customer?.title]);

    const finalProcurementKpiDAta = useMemo(() => {
        if (!procurementKpiData) return null;

        if (customer?.title === 'Safexpress') {
            return {
                ...procurementKpiData,
                data: {
                    ...procurementKpiData.data,
                    // totalDrawingsSubmitted: 55,
                    // drawingUnderReview: 0
                    // data: {
                    //     // ...procurementKpiData.data.data,
                    //     // Your specific Safexpress Overrides
                    //     totalSafeManHours: 0,
                    // }
                }
            };
        }

        return procurementKpiData;
    }, [procurementKpiData, customer?.title]);

    return (
        <>
            <Grid container spacing={2} sx={{ bgcolor: "#fff" }}>
                <Grid size={12} sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <Box>
                        <Typography variant="h5" sx={{ fontSize: '36px', fontWeight: 700, color: '#252525', lineHeight: "48px", letterSpacing: '-0.4px' }}>
                            Customer Dashboard {customer ? `- ${customer?.title}` : ""}
                        </Typography>
                        <Typography sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "100%",
                            letterSpacing: "0px",
                            fontFamily: "Outfit, sans-serif",
                            mt: "6px"
                        }}>Executive snapshot delivering critical project health insights for strategic decision-making.</Typography>
                    </Box>
                    <Box>
                        {/* {user?.email?.includes("ihg") ? <CardMedia
                            component="img"
                            image={ihgImg}
                            alt="image"
                            sx={{ height: 70 }}
                        /> : user?.email?.includes("psa") ? <CardMedia
                            component="img"
                            image={psaImg}
                            alt="image"
                            sx={{ height: 70 }}
                        /> : user?.email?.includes("nhlml") ? <CardMedia
                            component="img"
                            image={nhlmlImg}
                            alt="image"
                            sx={{ height: 70 }}
                        /> : null} */}
                        {customer ? <CardMedia
                            component="img"
                            image={customer?.icon}
                            alt={customer?.title || "image"}
                            sx={{ height: 70 }}
                        /> : null}
                    </Box>
                </Grid>
            </Grid>



            <Grid container justifyContent="space-between" sx={{ px: 3 }}>
                <Box>

                </Box>
                {sortedAssets?.length > 1 && <Box sx={{ flex: 1 }}>
                    <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
                        {filters.assetName && (
                            <Chip
                                label={
                                    <Typography variant="body2">
                                        <strong style={{ color: "#0E73F6" }}>Filter:</strong>{" "}
                                        <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                            {filters.assetName}
                                        </span>
                                    </Typography>
                                }
                                sx={{
                                    backgroundColor: "rgba(25, 118, 210, 0.08)",
                                    border: 0
                                }}
                                variant="outlined"
                                onDelete={resetAllFilters}
                            />
                        )}

                        <IconButton aria-label="delete" size="large"
                            ref={anchorRef}
                            onClick={handleToggle}
                        >

                            <TuneOutlinedIcon fontSize="large" />
                        </IconButton>
                        <Popper
                            open={open}
                            anchorEl={anchorRef.current}
                            placement="bottom-end"
                            transition
                            disablePortal={false}
                            // sx={{ zIndex: 4000 }}
                            onClick={(e) => e.stopPropagation()}
                            modifiers={[
                                {
                                    name: 'arrow',
                                    enabled: true,
                                    options: {
                                        element: arrowRef?.current,
                                    },
                                },
                            ]}
                        >
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper
                                        sx={{
                                            p: 2,
                                            // borderRadius: 1,
                                            boxShadow: "none",
                                            width: 300,
                                            borderRadius: 3,
                                            border: "2px solid #eef0f4",
                                            position: 'relative'
                                        }}
                                    >
                                        <ArrowDropUpRoundedIcon
                                            ref={arrowRef}
                                            sx={{
                                                position: "absolute",
                                                top: "-33px",
                                                right: "0px",
                                                fontSize: "60px",
                                                color: "white",
                                                filter: "drop-shadow(0px -1px 1px rgba(0,0,0,0.15))",
                                            }}
                                        />
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <Box>
                                                {open && (

                                                    <Formik
                                                        initialValues={filters}
                                                        validationSchema={validationSchema}
                                                        onSubmit={handleApplyFilters}
                                                        enableReinitialize
                                                    >
                                                        {({ values,
                                                            errors,
                                                            touched,
                                                            handleChange,
                                                            handleBlur,
                                                            handleSubmit,
                                                            isSubmitting,
                                                            setFieldValue,
                                                            resetForm,
                                                            setFieldTouched,
                                                            setTouched }) => {
                                                            // const subCatOptions = values?.category
                                                            //     ? subCategoryMap[values?.category]
                                                            //     : [];

                                                            return (
                                                                <Form>
                                                                    <Grid container spacing={2}>
                                                                        {/* ... your Category + Sub Category stuff ... */}

                                                                        {/* WBS TREE SECTION */}
                                                                        <Grid size={{ xs: 12, md: 12 }}>
                                                                            <Typography sx={{ mb: 1, mt: 1 }}>
                                                                                Asset Selector
                                                                            </Typography>


                                                                            <UserAssets
                                                                                assets={sortedAssets}
                                                                                onSelect={(node) => {
                                                                                    setFieldValue("assetId", node.id);
                                                                                    setFieldValue("assetName", node.name);
                                                                                }}
                                                                            />
                                                                            {values.assetName && (
                                                                                <Typography sx={{ mt: 1, fontSize: 12, color: "#555" }}>
                                                                                    Selected Asset: <strong>{values.assetName}</strong>
                                                                                </Typography>
                                                                            )}
                                                                        </Grid>


                                                                        <Grid size={12}>
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    justifyContent: "flex-end",
                                                                                    alignItems: "center"
                                                                                }}
                                                                            >
                                                                                {isApplyFilter && (
                                                                                    <Button
                                                                                        onClick={function () {
                                                                                            handleReset(resetForm);
                                                                                        }}
                                                                                        sx={{
                                                                                            textTransform: "none",
                                                                                            color: "#F15744",
                                                                                            fontSize: "14px",
                                                                                            lineHeight: "100%",
                                                                                            fontFamily: "Outfit, sans-serif",
                                                                                            borderRadius: "25px",
                                                                                            fontWeight: 500,
                                                                                            px: "20px",
                                                                                            py: "15px",
                                                                                        }}
                                                                                    >
                                                                                        Reset
                                                                                    </Button>
                                                                                )}

                                                                                <Button
                                                                                    type="submit"
                                                                                    variant="contained"
                                                                                    disabled={isSubmitting}
                                                                                    sx={{
                                                                                        backgroundColor: "#00344C",
                                                                                        borderRadius: "25px",
                                                                                        textTransform: "none",
                                                                                        fontWeight: 500,
                                                                                        fontSize: "14px",
                                                                                        lineHeight: "100%",
                                                                                        fontFamily: "Outfit, sans-serif",
                                                                                        color: "#FFFFFF",
                                                                                        px: "20px",
                                                                                        py: "15px",
                                                                                    }}
                                                                                >
                                                                                    Apply
                                                                                </Button>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Form>
                                                            );
                                                        }}
                                                    </Formik>

                                                )}
                                            </Box>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </Stack>
                </Box>}
            </Grid>

            <Grid size={12} container spacing={1.5} sx={{ m: 1.5, mt: 2 }}>
                <Grid size="auto">
                    <Kpis scheduelKpi={scheduleAssetData} isLoading={scheduleAssetLoading} scheduleKpiError={scheduleAssetError} customer={customer} />
                </Grid>

                <Grid size="grow">
                    <Assets sortedAssets={sortedAssets} isError={assetError} isLoading={assetsLoading} />
                </Grid>
            </Grid>


            <Grid container spacing={1.5} sx={{ m: 1.5, mt: 2 }}>
                <Grid size={{ md: 6 }} >
                    <Quality ncrData={finalNcrData} isLoading={ncrIsLoading} error={ncrIsError} assetError={assetError} />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <Safety data={finalHseData} isError={hseError} isLoading={hseLoading} />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <Schedule scheduleKpi={scheduleAssetData} isLoading={scheduleAssetLoading} error={scheduleAssetError} assetError={assetError} customer={customer} />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <DesignAndEngineering data={finalDesignData} isLoading={designLoading} error={designError} assetError={assetError} />
                </Grid>
                {customer?.title == 'Safexpress' &&
                    <Grid size={{ md: 6 }}>
                        <ProcurementKPI data={finalProcurementKpiDAta} isLoading={designLoading} error={designError} assetError={assetError} />
                    </Grid>
                }
                {customer?.title == 'Safexpress' &&
                    <Grid size={{ md: 6 }}>
                        <Dependencies data={finalProcurementKpiDAta} isLoading={designLoading} error={designError} assetError={assetError} />
                    </Grid>
                }

                {/* <Grid size={12} >
                    <ProjectDocuments />
                </Grid> */}
                <Grid size={12} >
                    <ProjectImages />
                </Grid>
                <Grid size={12} >
                    <CommentsAndRemarks type={"Safexpress"} />
                </Grid>
            </Grid>


        </>
    )
}

export default SafexpressDashboard
